var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmmptyroomAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 20.2857C13 19.0233 14.0233 18 15.2857 18H15.5455C18.5579 18 21 20.4421 21 23.4545V23.4545C21 23.7558 20.7558 24 20.4545 24H13.7826C13.3504 24 13 23.6496 13 23.2174V20.2857Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 26.344v-0.0103h-27.315v-9.8593c0-0.814-0.5823-1.4739-1.3005-1.4739h-0.084c-0.7182 0-1.3005 0.6599-1.3005 1.4739v16.176h2.685v-3.2736h24.63v3.2736h2.685v-6.3063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 21.578c0-1.1859-0.9745-2.1471-2.1764-2.1471l-11.647-1.4313c-1.2019 0-2.1764 0.9612-2.1764 2.147v2.253c0 0.5601 0 0.8401 0.109 1.054 0.0959 0.1882 0.2488 0.3411 0.437 0.437 0.2139 0.109 0.4939 0.109 1.054 0.109h12.8c0.5601 0 0.8401 0 1.054-0.109 0.1882-0.0959 0.3411-0.2488 0.437-0.437 0.109-0.2139 0.109-0.4939 0.109-1.054v-0.8216z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmmptyroomAlarm);
export default __webpack_public_path__ + "static/media/emmptyroom_alarm.eac647c0faafcbf5e07109adfd35e59b.svg";
export { ForwardRef as ReactComponent };